module.exports = __webpack_public_path__ + "media/images/04-8cea022426b33bb174eda8759edb23fa.jpg";